module.exports = __webpack_public_path__ + "img/design-photo.6d016b09.jpg";